module.exports = __webpack_public_path__ + "static/media/contactUs.26b36232.jpg";